
import { Check, Star } from "lucide-react";

export const LandingProduct = () => {
    return (
        <section className="py-24 bg-white overflow-hidden">
            <div className="container mx-auto px-4">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Simple on the inside. Beautiful on the outside.
                    </h2>
                    <p className="text-xl text-gray-500">
                        A dashboard you'll actually enjoy using, coupled with a contest page that converts.
                    </p>
                </div>

                <div className="relative max-w-5xl mx-auto">
                    {/* Main Dashboard Preview */}
                    {/* Main Dashboard Preview */}
                    <img
                        src="/images/analytics_dash.png"
                        alt="RaffleKit Analytics Dashboard"
                        className="w-full h-auto relative z-10 mb-8 sm:mb-0"
                        style={{ display: "block" }}
                    />

                    {/* Mobile Preview Overlay */}
                    <div className="absolute bottom-[-20px] right-[-10px] sm:right-[-40px] w-24 sm:w-48 z-20 hidden sm:block transform rotate-[-5deg] hover:rotate-0 transition-all duration-500">
                        <img
                            src="/images/contest_example.png"
                            alt="RaffleKit Contest Page"
                            className="w-full h-auto drop-shadow-2xl"
                            style={{ display: "block", width: "100%" }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};
